<template>
  <div :class="$style.box" @touchmove.prevent>
    <div :class="$style.content">
      <img :src="`${$cdnUrl}/freeKingdoms/sgin_bg.png`" @click="jump" />
      <img :src="`${$cdnUrl}/freeKingdoms/close.png`" @click="close" />
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const date = new Date();
    localStorage.setItem('promote-date', date);
  },
  methods: {
    jump() {
      this.$router.push({ name: 'activity.freeKingdoms' });
      this.$emit('close');
    },
    close() {
      console.log(312);
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" module>
.box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 300;
  .content {
    width: 100%;
    height: 386px;
    margin: 100px auto;
    position: relative;

    > img:nth-child(1) {
      width: 100%;
    }
    > img:nth-child(2) {
      width: 18px;
      position: absolute;
      right: 30px;
      top: 14px;
    }
  }
}
</style>